import React from 'react';
import { VerticalForms } from '../../../../commonv3/components/atoms/forms/vertical';
import { SubmissionFieldType, SubmitFieldState } from '../../../../commonv3/types/course_works';

export const FieldForm = ({ field }: { field: SubmitFieldState }) => {
  switch (field.definition.type) {
    case SubmissionFieldType.FILE:
      return <VerticalForms.FileInput label={field.definition.label} state={field.state} />;
    case SubmissionFieldType.MULTI_LINE_TEXT:
      return (
        <VerticalForms.MultiLineStringInput
          label={field.definition.label}
          state={field.state}
          placeholder={field.definition.parameters.placeholder}
        />
      );
    case SubmissionFieldType.SINGLE_LINE_TEXT:
    case SubmissionFieldType.GOOGLE_URL:
      return (
        <VerticalForms.StringInput
          label={field.definition.label}
          type="text"
          state={field.state}
          placeholder={field.definition.parameters.placeholder}
        />
      );
    default:
      return null;
  }
};
